import type { FC } from 'react';
import EmbedYoutube from '../utils/EmbedYoutube/EmbedYoutube';
import { AboutWrapper } from './About.styled';

interface AboutProps {}

const About: FC<AboutProps> = () => (
 <AboutWrapper>
   <header className="entry-header">
      <h1 className="entry-title" itemProp="headline">About</h1>			
   </header>
   <br/>
   <div className="entry-content clear" itemProp="text" style={{height: 'auto !important'}}>

      <div className="text-align-justify">
         <p>Welcome to LetsUnderstandJava, the ultimate destination for mastering the Java programming language! Our mission is to guide you through Java’s core concepts, from basic syntax to advanced techniques, ensuring you build a strong foundation and gain practical experience.</p>
         <p>We offer easy to understand java tutorials for beginners. It is an interactive and well-designed tutorial. In addition, we focus on helping you learn the basic fundamental concepts. In other words, it can even help a non-programmer to learn java from scratch. Above all, it will help you live long irrespective of the programming language.</p>
         <p>We break down complex Java concepts into easy-to-understand lessons, making learning engaging and effective. Join us on your journey to becoming a Java pro—explore our tutorials, interview questions, and connect with fellow learners.</p>
         <p>We have also created some video tutorials that will help you understand the concepts in a better way. To check our video tutorials, visit –  </p>
      </div>
      <p className="has-text-align-center youtube-link" style={{fontSize:'25px'}}><a aria-label="undefined (opens in a new tab)" href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA" target="_blank" rel="noreferrer noopener"><strong>Miss TecHack</strong></a></p>
      
      <EmbedYoutube videoType="video" videoList={["2qR0vYDDwlY"]} />

      <div style={{justifyItems: 'center'}}>
         <ul style={{display: 'flex', listStyle: 'none'}}>
            <li style={{margin: '10px', backgroundColor:'#3b5999', padding: '11px 24px', borderRadius:'32px'}}><a href="http://facebook.com/misstechack" title="Facebook" style={{color: '#fff'}}><span style={{fontSize: 'larger'}} className="fa fa-facebook"></span></a></li>
            <li style={{margin: '10px', backgroundColor:'#ef0175', padding: '11px 24px', borderRadius:'32px'}}><a href="http://instagram.com/misstechack" title="Instagram" style={{color: '#fff'}}><span  style={{fontSize: 'larger'}} className="fa fa-instagram"></span></a></li>
            <li style={{margin: '10px', backgroundColor:'red', padding: '11px 24px', borderRadius:'32px'}}><a href="https://youtube.com/channel/UCpIueiXyq5nhTJTDuw2DQnA" title="YouTube" style={{color: '#fff'}}><span  style={{fontSize: 'larger'}} className="fa fa-youtube"></span></a></li>
         </ul>
      </div>

   </div>
 </AboutWrapper>
);

export default About;
